module.exports = __webpack_public_path__ + "static/img/run-waiting.80ebff21.png";